//米兰冬奥会 full
import PlatfromCSMeetMilanWinterGamesFull from '@containers/platfrom_compreSportsMeet/milanWinterGamesFull_WOG.vue'

export default {
  PlatfromCSMeetMilanWinterGamesFull,
}
